import React from 'react';
import { AddRecipient as AddRecipientScreen } from '@send-legacy-containers/AddRecipient';

const AddRecipient = () => <AddRecipientScreen />;

export default AddRecipient;
